import React, { useEffect, useState } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { getActiveLanguage, getLabelsByLanguage, useQuery } from '../../../utilites/util';
import LoadingIndicator from '../xnp/common/loading-indicator/LoadingIndicator';
import ErrorInformation from './error/ErrorInformation';
import StepList from './stepper/StepList';
import TopupInputStep from './steps/TopupInputStep';
import TopupOverviewStep from './steps/TopupOverviewStep';
import TopupTransactionOverview from './transaction-overview';
import { useMaintenanceMode } from '../../../hooks/useMaintenanceMode';
import Config from '../../../config/config';
import './scss/index.scss';

const TopupPageContainer: React.FC = () => {
  const labels = getLabelsByLanguage();
  const language = getActiveLanguage();

  const history = useHistory();
  const query = useQuery();

  const step = query.get('step');

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  const [activeStep, setActiveStep] = useState(Number(step));

  const { isInMaintenanceMode, isFetchingStatus } = useMaintenanceMode('topup');

  const handleStepChange = (step: number) => {
    setActiveStep(step);
    setLoading(false);
    history.push(`?step=${step}`);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    if (!searchParams.has('step')) {
      setActiveStep(1);
      setLoading(false);
    }
  }, []);

  if (isInMaintenanceMode) {
    return <Redirect to={`${Config.prefixUrl}/${language}/maintenance`} />;
  }

  return (
    <div className="topup-container mb-5 content-under-header">
      <h1 className="text-center mt-4 mb-4 text-30">
        <span className="yettel-bold-font">{labels.topupText1}</span>
      </h1>
      <div>
        <h2 className="text-center mt-3 mb-3 text-20">{labels.topupText2}</h2>
      </div>
      <div>
        <p className="text-center text-20 mt-4 mb-5">
          <a
            href="/sr/privatni/usluge/ostale-usluge/placanje-racuna/pripejd-dopune/"
            target="_blank"
            className="yettel-bold-font yettel-link"
          >
            {labels.topupText3}
            <span>
              <MdOutlineKeyboardArrowRight />
            </span>
          </a>
        </p>
      </div>
      <section className="ytope yettel-font mt-5 text-16">
        <div className="mb-5">
          <StepList activeStep={activeStep} />
          {errors.length > 0 && <ErrorInformation errors={errors} />}
        </div>

        {(loading || isFetchingStatus) && (
          <div className="mt-5 mb-5 pt-5 pb-5 d-flex justify-content-center">
            <LoadingIndicator />
          </div>
        )}

        {!(loading || isFetchingStatus) && activeStep === 1 && (
          <div className="ytope-fieldset">
            <TopupInputStep setLoading={setLoading} setErrors={setErrors} handleStepChange={handleStepChange} />
          </div>
        )}

        {!(loading || isFetchingStatus) && activeStep === 2 && (
          <div className="ytope-fieldset">
            <TopupOverviewStep handleStepChange={handleStepChange} setLoading={setLoading} setErrors={setErrors} />
          </div>
        )}

        {!(loading || isFetchingStatus) && activeStep === 3 && (
          <TopupTransactionOverview handleStepChange={handleStepChange} />
        )}
      </section>
    </div>
  );
};

export default TopupPageContainer;
